/**
 * Moneda de facturación de una clínica (ARS por defecto). Cada factura y cada cobro traen la suya:
 * nunca se suman montos de distinta moneda.
 */
export type Moneda = 'ARS' | 'USD';

export const MONEDAS: readonly Moneda[] = ['ARS', 'USD'];

export function normalizeMoneda(value: unknown): Moneda {
  return String(value ?? '').trim().toUpperCase() === 'USD' ? 'USD' : 'ARS';
}

/** "$ 12.345,00" en pesos, "US$ 120,00" en dólares. `decimals: false` redondea a entero. */
export function formatMoney(
  value: number | null | undefined,
  moneda: Moneda | null | undefined = 'ARS',
  opts: { decimals?: boolean } = {}
): string {
  const n = Number(value);
  const safe = Number.isFinite(n) ? n : 0;
  const decimals = opts.decimals ?? true;
  const body = safe.toLocaleString('es-AR', {
    minimumFractionDigits: decimals ? 2 : 0,
    maximumFractionDigits: decimals ? 2 : 0,
  });
  return `${moneda === 'USD' ? 'US$' : '$'} ${body}`;
}

/** Input de precio USD de catálogo: admite decimales (coma o punto). */
export function sanitizeUsdInput(raw: string): string {
  return raw.replace(/[^\d.,]/g, '').replace(',', '.');
}

/** '' = sin precio USD (null): la factura de una clínica en dólares lo trae en 0. */
export function parseUsdInput(raw: string): number | null {
  const v = raw.trim();
  if (v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

export function usdToInput(value: number | null | undefined): string {
  return value == null ? '' : String(value);
}
